import { render, staticRenderFns } from "./MessageAttachments.vue?vue&type=template&id=8e146f96&scoped=true"
import script from "./MessageAttachments.vue?vue&type=script&lang=js"
export * from "./MessageAttachments.vue?vue&type=script&lang=js"
import style0 from "./MessageAttachments.vue?vue&type=style&index=0&id=8e146f96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e146f96",
  null
  
)

export default component.exports